// Provider-neutral credential store — the single boundary for auth/session state.
// Web uses localStorage today; a future native (Expo) client injects an
// expo-secure-store / Keychain adapter via setCredentialImpl WITHOUT touching any
// call site, and the web build can later swap to httpOnly-cookie-backed reads.
// Keeping this in one place makes it easy to harden and to audit exactly what is
// persisted on the client.
const KEYS = { token: "atlas_token", tenant: "atlas_tenant", entity: "atlas_entity" };

const webImpl = {
  get: (k) => { try { return localStorage.getItem(k); } catch { return null; } },
  set: (k, v) => { try { (v == null) ? localStorage.removeItem(k) : localStorage.setItem(k, v); } catch { /* storage unavailable */ } },
};

let impl = webImpl;
// Native clients call this once at boot with a SecureStore-backed adapter.
export function setCredentialImpl(next) { if (next) impl = next; }

export const credentials = {
  getToken: () => impl.get(KEYS.token),
  setToken: (v) => impl.set(KEYS.token, v || null),
  getTenant: () => impl.get(KEYS.tenant),
  setTenant: (v) => impl.set(KEYS.tenant, v || null),
  getEntity: () => impl.get(KEYS.entity),
  setEntity: (v) => impl.set(KEYS.entity, v || null),
  clear: () => { impl.set(KEYS.token, null); impl.set(KEYS.tenant, null); impl.set(KEYS.entity, null); },
};
